var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5205 17.7523L17.4371 11.8357C16.4417 11.4201 15.5376 10.8129 14.7764 10.0486C14.0117 9.28721 13.4042 8.38289 12.9885 7.3871L7.07189 13.3037C6.6103 13.7653 6.37911 13.9965 6.18072 14.2509C5.94641 14.5511 5.7455 14.8759 5.58154 15.2196C5.44314 15.5108 5.33995 15.8212 5.13356 16.4404L4.04399 19.7067C3.99385 19.8562 3.98641 20.0168 4.02251 20.1703C4.05861 20.3239 4.13683 20.4643 4.24836 20.5759C4.3599 20.6874 4.50033 20.7656 4.65388 20.8017C4.80743 20.8378 4.968 20.8304 5.11756 20.7802L8.38384 19.6907C9.00382 19.4843 9.31341 19.3811 9.6046 19.2427C9.94858 19.0787 10.2734 18.8779 10.5734 18.6435C10.8278 18.4451 11.0589 18.2139 11.5205 17.7523ZM19.0787 10.1942C19.6686 9.60428 20 8.80416 20 7.96988C20 7.1356 19.6686 6.33549 19.0787 5.74556C18.4887 5.15564 17.6886 4.82422 16.8543 4.82422C16.0201 4.82422 15.2199 5.15564 14.63 5.74556L13.9204 6.45514L13.9508 6.54393C14.3005 7.54447 14.8727 8.45259 15.6244 9.19984C16.394 9.97397 17.3339 10.5575 18.3691 10.9038L19.0787 10.1942Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateUserProfile);
export default __webpack_public_path__ + "static/media/update_user_profile.06a4cd6ce9c89af179dd7e533d5c9d2a.svg";
export { ForwardRef as ReactComponent };